module.exports = __webpack_public_path__ + "static/img/black.2098ba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/black.png
// module id = RPLP
// module chunks = 8